module.exports = __webpack_public_path__ + "static/media/img-6.14a87195.png";